import {styled} from '@mui/material'
import Texts from 'appearance/texts'
import {Controller} from 'react-hook-form'
import {orientationStyles} from 'services/utils/formUtils'
import {FormErrorText} from '.'
import Select from '../Select'
import {useDeviceDetect} from 'services/hooks'

const FormSelect = ({
    name,
    label,
    LabelComponent,
    control,
    formErrors,
    required,
    rules,
    type,
    disabled,
    orientation = 'horizontal',
    readOnly,
    options,
    selectWidth,
    style,
    editMode = true,
    itemName,
    height,
    selectStyle,
    placeholder,
    format,
    labelFontSize,
}) => {
    const {isMobile} = useDeviceDetect()
    return (
        <Container style={{...orientationStyles[orientation], ...style}}>
            {LabelComponent ? (
                <LabelComponent />
            ) : (
                <Label
                    isMobile={isMobile}
                    fontSize={labelFontSize}
                    style={{marginBottom: orientation === 'vertical' && 4}}>
                    {label}
                </Label>
            )}
            <Controller
                name={name}
                control={control}
                rules={rules || {required}}
                render={({field: {onChange, value}}) =>
                    editMode && !readOnly ? (
                        <Select
                            name={name}
                            width={selectWidth}
                            itemName={itemName}
                            onChange={(changeVal) => {
                                if (format) {
                                    changeVal.target.value = options.find(
                                        (option) =>
                                            format(option) ===
                                            changeVal.target.value
                                    )
                                }
                                onChange(changeVal)
                            }}
                            value={
                                value === null
                                    ? undefined
                                    : format?.(value) || value
                            }
                            fullWidth={true}
                            required={required}
                            disabled={disabled}
                            type={type}
                            containerStyle={{flex: 3, ...style}}
                            options={options.map(
                                (option) => format?.(option) || option
                            )}
                            height={height}
                            selectStyle={selectStyle}
                            placeholder={placeholder}
                            format={format}
                        />
                    ) : (
                        <Value>{format?.(value) || value}</Value>
                    )
                }
            />
            {formErrors?.[name] && (
                <FormErrorText>{formErrors?.[name]?.message}</FormErrorText>
            )}
        </Container>
    )
}

export default FormSelect

const Container = styled('div')`
    display: flex;
`

const Label = styled('div')`
    font-size: ${({fontSize, isMobile}) => fontSize || (isMobile ? 14 : 18)}px;
    font-weight: bold;
    flex: 2;
    font-family: 'Open Sans', sans-serif;
`
const Value = styled(Texts.RegularText)`
    flex: 4;
`
